export function Star() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M7.43457 0L9.18705 5.39358H14.8582L10.2701 8.727L12.0226 14.1206L7.43457 10.7872L2.84652 14.1206L4.599 8.727L0.0109425 5.39358H5.68209L7.43457 0Z"
        fill="#F0ED9C"
      />
    </svg>
  )
}
